import Cookies from "universal-cookie";
export const cookie = new Cookies();

export function GetJWT() {
  var token = cookie.get("token_energreen");
  if (!!token) return "Bearer " + token;
  return null;
}
